// extracted by mini-css-extract-plugin
export var messageSideLeft = "_o6-1";
export var messageSideRight = "_o6-2";
export var orderLookupBubbleContainer = "_o6-0";
export var submitButton = "_o6-3";